module.exports = __webpack_public_path__ + "static/media/blog.edc29b83.jpg";